<!-- Header using PrimeNG Toolbar - Fixed at top -->
<p-toolbar class="border-b flex-shrink-0 h-[74px]">
  <ng-template pTemplate="start">
    <div class="flex items-center gap-3">
      <p-button
        icon="pi pi-bars"
        [rounded]="true"
        size="small"
        (onClick)="onMenuToggle()"
        [ariaLabel]="'home.toggleMenu' | translate"
      />
    </div>
  </ng-template>

  <ng-template pTemplate="center">
    <div class="flex flex-col items-center text-center">
      @if (headerService.loading()) {
      <!-- Skeleton for title -->
      <p-skeleton width="15rem" height="1.5rem" class="mb-2" />
      <!-- Skeleton for subtitle -->
      <p-skeleton width="20rem" height="1rem" />
      } @else { @if (headerService.title()) {
      <h1 class="text-xl font-semibold">{{ headerService.title() }}</h1>
      } @if (headerService.subtitle()) {
      <p class="text-sm text-secondary">{{ headerService.subtitle() }}</p>
      } }
    </div>
  </ng-template>

  <ng-template pTemplate="end">
    <div class="flex items-center gap-4">
      <!-- Save Indicator -->
      @if (headerService.saveIndicator()) {
      <div class="flex items-center gap-2 text-sm">
        @switch (headerService.saveIndicator()!.status) { @case ('unsaved') {
        <i class="pi pi-circle-fill text-amber-500" style="font-size: 0.5rem"></i>
        <span class="text-secondary">{{ 'common.unsaved' | translate }}</span>
        } @case ('saving') {
        <i class="pi pi-spin pi-spinner text-primary" style="font-size: 0.875rem"></i>
        <span class="text-secondary">{{ 'common.saving' | translate }}</span>
        } @case ('saved') {
        <i class="pi pi-check-circle text-green-500" style="font-size: 0.875rem"></i>
        <span class="text-secondary"
          >{{ 'common.savedAt' | translate }}:
          {{ formatSaveTime(headerService.saveIndicator()!.lastSavedAt!) }}</span
        >
        } }
      </div>
      }

      <!-- Buttons -->
      @if (headerService.loading()) {
      <!-- Skeleton for buttons -->
      <p-skeleton width="6rem" height="2.5rem" borderRadius="6px" />
      <p-skeleton width="6rem" height="2.5rem" borderRadius="6px" />
      } @else { @for (button of headerService.buttons(); track $index) {
      <p-button
        [label]="button.label"
        [icon]="button.icon"
        [severity]="button.severity || 'primary'"
        [outlined]="button.outlined || false"
        [disabled]="button.disabled || false"
        [loading]="button.loading || false"
        (onClick)="button.action()"
      />
      } }
    </div>
  </ng-template>
</p-toolbar>
